import React from 'react';
import { Box, MenuItem, Tooltip, Typography } from '@mui/material';
import CommonDialog from 'components/commonDialog/CommonDialog';
import { getDateFormat , truncateComment } from 'utils/utils';
import EditIcon from 'assets/images/EditIcon.svg';
import MailLogo from 'assets/images/MailLogo.svg';
import Calendar from 'assets/images/Calender.svg';
import CallLogo from 'assets/images/CallLogo.svg';
import location from 'assets/images/locationLogo.svg';

const AboutCard = (props) => {
  const { details, open, toggle, type, onDialog, editDialogData, editButton } = props;
  // ----FormatingDate---
  const handleDateFormating = (data) => {
    return getDateFormat(data, 'moreDetails');
  };

  return (
    <Box className="width100">
      <Box className="justifyBetween width100">
        <Typography variant="body2" className="fw600">
          About
        </Typography>

       {editButton &&  <img
          src={EditIcon}
          onClick={() => toggle()}
          alt="EditIcon"
          role="presentation"
          className="img13"
        />}
      </Box>
      <Box className="mt30">
        <MenuItem className="iconAlign justifyCenter cursorDefault">
          <img src={MailLogo} alt="mail icon" />
          <Typography variant="body3" className="pl20">
            <Tooltip
              title={details?.email }
              placement="bottom"
            >
              {truncateComment(
                details?.email,
                25
              )}
            </Tooltip>
          </Typography>
        </MenuItem>
        <MenuItem className="iconAlign justifyCenter cursorDefault">
          <img src={CallLogo} alt="mail icon" />
          <Typography variant="body3" className="pl20">
            {details?.mobile ? details?.mobile : 'Not Available'}
          </Typography>
        </MenuItem>
        <MenuItem className="iconAlign justifyCenter cursorDefault">
          <img src={location} alt="mail icon" />
          <Typography variant="body3" className="pl20">
            {details?.location ? details?.location : 'Not Available'}
          </Typography>
        </MenuItem>
        <MenuItem className="iconAlign justifyCenter cursorDefault">
          <img src={Calendar} alt="mail icon" />
          <Typography variant="body3" className="pl20">
            {details?.createdAt
              ? handleDateFormating(details?.createdAt)
              : 'Not Available'}
          </Typography>
        </MenuItem>
      </Box>
      <CommonDialog
        className="mb20"
        open={open}
        handleClose={toggle}
        formData={editDialogData(details)}
        button={'dialogButton'}
        onSubmittBtn={onDialog}
        type={`Edit ${type}`}
        selectType={'edit'}
        editData={editDialogData(details)}
      />
    </Box>
  );
};

export default AboutCard;
